
/* ============================== src/utils/format.js ============================== */
// src/utils/format.js
//
// Единая точка форматирования денежных значений для UI и CSV.
// Варианты «с ₽» и «без ₽» - части одного модуля, а не два разных
// форматтера в разных файлах: иначе UI и CSV разъедутся по правилам.
//
// Правила:
//   - выручка - всегда до копеек (2 знака);
//   - ставка - от 0 до 2 знаков без принудительного «,00»
//     (3500 отображается как «3 500», 3500.5 - как «3 500,5»);
//   - пустое значение (null, undefined, "") - «-» в UI и «» в CSV.
//
// Здесь же - formatSize для размеров файлов: единственная точка
// форматирования размера, используется и в FileManager, и в
// CommentFiles. Раньше функция дублировалась локально.

const RUB_FMT = new Intl.NumberFormat("ru-RU", {
  style: "currency",
  currency: "RUB",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const RATE_FMT = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const toNum = (v) => {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

/** «12 345,67 ₽» - для UI-таблиц отчётов. null/"" → «-». */
export function formatRub(value) {
  const n = toNum(value);
  return n == null ? "-" : RUB_FMT.format(n);
}

/** Ставка ₽/ч без символа: «3 500,5». Символ - в заголовке колонки. */
export function formatRate(value) {
  const n = toNum(value);
  return n == null ? "-" : RATE_FMT.format(n);
}

/**
 * Выручка для CSV: только число с двумя знаками, без ₽ и без
 * разделителей - чтобы Excel/LibreOffice не запутались в запятых
 * и символах валюты.
 */
export function formatRubCsv(value) {
  const n = toNum(value);
  return n == null ? "" : n.toFixed(2);
}

/** Ставка для CSV: как formatRate, но пусто вместо «-». */
export function formatRateCsv(value) {
  const n = toNum(value);
  return n == null ? "" : RATE_FMT.format(n);
}

/**
 * Человекочитаемый размер файла: «512 Б», «1.5 КБ», «2.3 МБ».
 * Единственная точка форматирования размера - используется и в
 * FileManager, и в CommentFiles.
 */
export function formatSize(size) {
  const n = Number(size);
  if (!Number.isFinite(n) || n < 0) return "-";
  if (n < 1024) return n + " Б";
  if (n < 1048576) return (n / 1024).toFixed(1) + " КБ";
  return (n / 1048576).toFixed(1) + " МБ";
}
